import { format } from "date-fns";
import { useTranslations } from "next-intl";

import IconId from "@/icons/id-card.svg";
import IconCalendar from "@/icons/ui/forms/calendar.svg";
import IconEye from "@/icons/ui/forms/eye.svg";
import { cn } from "@/utils/cn";

interface ObjectDetailMetaProps {
  id?: string;
  customId?: string;
  createdAt?: string;
  updatedAt?: string;
  watchCount?: number;
  className?: string;
}

export function ObjectDetailMeta({
  id,
  customId,
  createdAt,
  updatedAt,
  watchCount,
  className,
}: ObjectDetailMetaProps) {
  const t = useTranslations();

  // Use createdAt as primary date, fallback to updatedAt for backwards compatibility
  const displayDate = createdAt || updatedAt;

  return (
    <div
      className={cn(
        "flex items-center justify-between gap-4 md:gap-12 flex-wrap",
        "md:w-auto text-gray-1200 text-sm",
        className,
      )}
    >
      {displayDate && (
        <div className={"flex items-center gap-4"}>
          <IconCalendar
            width={20}
            height={20}
          />
          <span>{format(new Date(displayDate), "dd.MM.yyyy")}</span>
        </div>
      )}

      {watchCount && (
        <div className={"flex items-center gap-4"}>
          <IconEye
            width={20}
            height={20}
          />
          <span>{watchCount}</span>
        </div>
      )}

      <div className={"flex items-center gap-4"}>
        <IconId
          width={20}
          height={20}
        />
        <span>
          {t("ID")}: {customId || id}
        </span>
      </div>
    </div>
  );
}
